import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
// import AboutArtist from '../containers/AboutArtistContainer';
import AlbumArt from '../containers/AlbumArtContainer';
import MetaInfo from '../containers/MetaInfoContainer';
import LastPlayedSongs from '../containers/LastPlayedSongsContainer';
// import FacebookComments from '../../../common/comments/Comments';
// import Banner from '../../../common/Banner/Banner';
// import InteractiveContainer from '../../../common/interactiveContainer/InteractiveContainer';


// const topBannerConfig = {
//     // title: "CONTINUE DEPOIS DA PUBLICIDADE", // no title here as this defines the appeareance
//     class: 'col-11',
//     adUnit: 'a1nova-aovivo-top_multi_sizes',
//     sizes: [[970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [320, 50], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [300, 100], [320, 50], [234, 60]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };
// const firstBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-aovivo-first_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// const fifthBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-aovivo-fifth_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };


class AoVivo extends Component {
    componentDidMount() {
        // go to top
        animateScrollTo(0, { speed: 700 });
    }

    render() {
        return (
            <section className="sectionAovivo">
                {/* <Banner key={topBannerConfig.adUnit} config={topBannerConfig} /> */}
                {/*
                <header>
                    <h1>Venha ouvir a melhor rádio fm online do brasil</h1>
                    <p className="pageSubtitle">Os últimos lançamentos, os clássicos das décadas de 70, 80, 90 e as músicas que marcaram época</p>
                </header>
                */}
                <div className="aovivo-content">
                    <div className="albumArt">

                        <AlbumArt />

                    </div>
                    {/* <InteractiveContainer maxScreenSizeForFixed="isExtraSmall" /> */}

                    <MetaInfo />
                </div>
                {/* <Banner key={firstBannerConfig.adUnit} config={firstBannerConfig} /> */}
                <LastPlayedSongs />
                {/*  */}

                {/* <AboutArtist /> */}


                {/* <div className="breakLine" /> */}
                {/* <Banner key={secondBannerConfig.adUnit} config={secondBannerConfig} /> */}
                {/* <Banner key={thirdBannerConfig.adUnit} config={thirdBannerConfig} /> */}
                {/* <VideosSlider playlistId={'PLDw1hkQ8FWA2s5gjAQ4QrypYYrCRCA-TW'} numVideos={10} /> */}
                {/* <AovivoNews /> */}

                {/* <Banner key={fifthBannerConfig.adUnit} config={fifthBannerConfig} /> */}

                {/*
                <div className="aovivo-FacebookComments">
                    <FacebookComments location="/ouvir-radio-online" />
                </div>
                */}

            </section>
        );
    }
}


export default AoVivo;
